import { render, staticRenderFns } from "./NewsLetter.vue?vue&type=template&id=70ba9756&"
import script from "./NewsLetter.vue?vue&type=script&lang=js&"
export * from "./NewsLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports